module.exports = __webpack_public_path__ + "static/smi2Mini-a40f26a75a37590a3b00885eaa74cb09.png";